import { IndicatorFactType, IndicatorName } from '@/api/rest/resources/types/fact';
import { GraphTileType } from '@/api/rest/resources/types/widget';

export const availableGraphsToIndicatorNames = {
  [GraphTileType.historic_below_ground_carbon]: IndicatorName.permanent_soil_carbon_total,
  [GraphTileType.historic_above_ground_carbon]: IndicatorName.above_ground_carbon_total,
  [GraphTileType.historic_water_soil_moisture]: IndicatorName.water_fc_total,
  // TODO: MVP-7133 - enable when zoom is added to precipitation soil moisture graph
  // TODO: MVP-7605 - enable when it becames clear whether precipitation soil moisture can be shown at an organization level
  // [GraphTileType.historic_precipitation_soil_moisture]: R1FactType.soil_moisture_smooth_timeseries_total,
  [GraphTileType.social_life_expectancy]: IndicatorName.social_life_expectancy,
  [GraphTileType.protected_on_farm_habitat]: IndicatorName.biodiversity_buffer_zone_pct,
  [GraphTileType.ndvi]: IndicatorName.vegetation_condition_ndvi,
  [GraphTileType.canopy_cover]: IndicatorName.canopy_cover_pct,
  [GraphTileType.canopy_height]: IndicatorName.canopy_height,
  [GraphTileType.historic_habitat_intactness]: IndicatorName.habitat_intactness_total,
  [GraphTileType.historic_habitat_intactness_threats_breakdown]: IndicatorName.threat_breakdown_total,
  [GraphTileType.historic_deforestation]: IndicatorName.deforestation_total,
} as const;

export const ALL_INDICATOR_FACT_TYPES = Object.values(availableGraphsToIndicatorNames) as IndicatorFactType[];

export const INDICATORS_WITH_GRAPH_TYPE_TOGGLE: GraphTileType[] = [
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
  GraphTileType.protected_on_farm_habitat,
  GraphTileType.social_life_expectancy,
  GraphTileType.ndvi,
  GraphTileType.historic_habitat_intactness,
  GraphTileType.historic_habitat_intactness_threats_breakdown,
  GraphTileType.historic_deforestation,
  GraphTileType.canopy_cover,
  GraphTileType.canopy_height,
];

export const INDICATORS_WITH_ZOOM: GraphTileType[] = [
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
  GraphTileType.protected_on_farm_habitat,
  GraphTileType.social_life_expectancy,
  GraphTileType.ndvi,
  GraphTileType.canopy_cover,
];

export const INDICATORS_WITH_PER_HA_TOGGLE: GraphTileType[] = [
  GraphTileType.historic_below_ground_carbon,
  GraphTileType.historic_above_ground_carbon,
  GraphTileType.historic_water_soil_moisture,
];
